require('./bootstrap');
require('bootbox');
require('jquery-validation');
require('toastify-js');
import lightbox from 'lightbox2/dist/js/lightbox';

$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
  },
});

$(document).ready(function () {
  App.Lang.setLanguage(LANG);

  $('.toast').each(function () {
    let $toast = $(this);

    if ($toast.hasClass('error')) {
      App.Helper.showMessageError($toast.html());
    } else {
      App.Helper.showMessageSuccess($toast.html());
    }

    $toast.remove();
  });

  App.Helper.bindSidebar();
  
  App.Lang.setLightboxDefaults(lightbox);

  /* Sometimes navigation is calculated too early. Fixed with setTimeout. */
  window.setTimeout(function() {
    App.Helper.navigation();
  }, 100)

  $(window).on('resize', function (e) {
    App.Helper.navigation();
  });
});

global.App = {
  constants: {
    ELEMENT_TYPE_HEADER: 0,
    ELEMENT_TYPE_TEXT: 1,
    ELEMENT_TYPE_IMAGE: 2,
    ELEMENT_TYPE_BR: 3,
  },
};
